/* eslint-disable global-require */
/* eslint-disable no-underscore-dangle */
import React, { memo } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { colorVariables } from 'desktop/theme/variables';

const Icon = ({ icon, color, size, width, height, viewBox, className }) => {
  const Component = icon;

  return <Component
    className={className}
    fill={_.get(colorVariables, color, color)}
    width={viewBox !== 'none' ? size : width}
    height={viewBox !== 'none' ? size : height}
    viewBox={viewBox !== 'none' ? viewBox : '0 0 24 24'}
  />
};

Icon.propTypes = {
  icon: PropTypes.shape({
    render: PropTypes.func,
  }).isRequired,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  size: PropTypes.number,
  viewBox: PropTypes.string,
  className: PropTypes.string,
};

Icon.defaultProps = {
  color: 'white',
  width: null,
  height: null,
  size: null,
  viewBox: null,
  className: '',
};

export default memo(Icon);
